import React from 'react';
import PropTypes from 'prop-types';

import './_style.scss';


const getClassName = (disabled, customClassName, type) => {
	let className = customClassName ? `${customClassName} general-button` : 'general-button';
	if (disabled) {
		className = `${className} disabled`;
	}
	if (type) {
		className = `${className} ${type}`;
	}
	return className;
};

const GeneralButton = (props) => <button
	className={getClassName(props.disabled, props.className, props.type)}
	id={props.id}
	onClick={props.onClick}
	type='button'>
	{props.icon ? props.icon : null}
	{props.text && <div className='button-text'>{props.text}</div>}
</button>;

GeneralButton.propTypes = {
	className: PropTypes.string,
	id: PropTypes.string,
	disabled: PropTypes.any,
	icon: PropTypes.shape({}),
	onClick: PropTypes.func,
	text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	type: PropTypes.any
};

export default GeneralButton;
